<div class="copyright">
    <div class="container">
        <p class="copyright__text">
            © Serasa Experian - São Paulo: Al. dos Quinimuras, 187, Planalto Paulista - CEP 04068-900, São Paulo, SP - CNPJ/MF nº
            62.173.620/0001-80, IE Isenta.
        </p>
        <p class="copyright__text">
            © Serasa Experian - São Carlos: Av. Doutor Heitor José Reali, 360 - CEP 13571-385, São Carlos, SP - Inscrita no CNPJ/MF nº
            62.173.620-0093-06.
        </p>
    </div>
</div>
